import { useState } from 'react';
import type DragAndDropProperties from './DragAndDrop.properties.ts';
import type { MarketComponentMarketComponentIO } from '../../generated/fresh-guard-api';
import type { ReactZoomPanPinchState } from 'react-zoom-pan-pinch';
import { DragAndDropContext } from './DragAndDrop.context.tsx';

export const DragAndDropProvider = (props: DragAndDropProperties) => {
  const [marketComponent, setMarketComponent] = useState<MarketComponentMarketComponentIO | null>(
    null
  );
  const [droppableArea, setDroppableArea] = useState<HTMLElement | null>(null);
  const [transformState, setTransformState] = useState<ReactZoomPanPinchState | null>(null);

  return (
    <DragAndDropContext.Provider
      value={{
        marketComponent,
        setMarketComponent,
        droppableArea,
        setDroppableArea,
        transformState,
        setTransformState,
      }}
    >
      {props.children}
    </DragAndDropContext.Provider>
  );
};
